import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/home/Home";
import TorumPayCard from "./pages/torumpaycard/TorumPayCard";
import Referral from "./pages/referral/Referral";
import Company from "./pages/company/Company";
import Career from "./pages/career/Career";
import Announcements from "./pages/announcements/Announcements";
import Features from "./pages/features/Features";
import Fees from "./pages/fees/Fees";
import TermsOfUse from "./pages/termsOfUse/TermsOfUse";
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy";
import CookiePolicy from "./pages/cookiePolicy/CookiePolicy";
import Security from "./pages/security/Security";
import ComplianceInformation from "./pages/complianceInformation/ComplianceInformation";
import TravelRule from "./pages/travelRule/TravelRule";
import Learn from "./pages/learn/Learn";

import AppLayout from "./components/AppLayout/AppLayout";
import Modal from "./components/Modal/Modal";
import { ROUTES } from "./constants/navigation";
import { PAGES } from "./constants/pages";

import TorumPayLogo from "./assets/svg/torum-pay-logo.svg";
import IntroImg from "./assets/png/outro-cta-img.png";

import "./styles/variables.scss";
import "./App.scss"; // Ensure you include your fallback styles here

const LoadingScreen = ({ slideOut, slideOutv2, fadeOut }) => {
  const [typedText, setTypedText] = useState("");
  const fullText = "Your Gateway to Crypto Payments";

  useEffect(() => {
    let currentIndex = 0;

    const typingEffect = () => {
      setTypedText(fullText.slice(0, currentIndex + 1));
      currentIndex++;
      if (currentIndex >= fullText.length) {
        clearInterval(typingInterval);
      }
    };

    const typingInterval = setInterval(typingEffect, 50);

    return () => clearInterval(typingInterval);
  }, [fullText]);

  return (
    <div className={`intro-screen ${fadeOut ? "fade-out" : ""}`}>
      <div className={`logo-wrapper  ${slideOut ? "slide-left" : ""}`}>
        <img
          src={TorumPayLogo}
          alt="torum-pay-logo"
          className="torum-pay-logo"
        />
      </div>
      <div className={`intro-text ${slideOutv2 ? "slide-left-more" : ""}`}>
        <p className="Ft-20s-20l fw500">{typedText}</p>
      </div>
    </div>
  );
};

function App() {
  // const [isModalVisible, setModalVisible] = useState(false);
  // const [isUserAgreed, setUserAgreed] = useState(null);

  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const [slideOut, setSlideOut] = useState(false);
  const [slideOutv2, setSlideOutv2] = useState(false);

  useEffect(() => {
    const slideTimer = setTimeout(() => {
      setSlideOut(true);
    }, 4200);

    const slideTimerv2 = setTimeout(() => {
      setSlideOutv2(true);
    }, 4300);

    const fadeOutTimer = setTimeout(() => {
      setFadeOut(true);
    }, 4600);

    const hideTimer = setTimeout(() => {
      setLoading(false);
    }, 5600);

    return () => {
      clearTimeout(slideTimer);
      clearTimeout(slideTimerv2);
      clearTimeout(fadeOutTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  // ===== Agreement modal logic (commented out) =====
  /*
  useEffect(() => {
    const agreement = localStorage.getItem("userAgreed");
    if (agreement === "true") {
      setUserAgreed(true);
      setModalVisible(false);
    } else if (agreement === "false") {
      setUserAgreed(false);
      setModalVisible(false);
    } else {
      setModalVisible(true);
    }
  }, []);

  useEffect(() => {
    if (isModalVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isModalVisible]);

  const handleAgree = () => {
    localStorage.setItem("userAgreed", "true");
    setUserAgreed(true);
    setModalVisible(false);
  };

  const handleDisagree = () => {
    localStorage.removeItem("userAgreed");
    setUserAgreed(false);
    setModalVisible(false);
  };

  if (isUserAgreed === false) {
    return (
      <div className="fallback-container">
        <p className="fallback-title">Access Denied</p>
        <p className="fallback-desc">
          You must agree to the terms to view this website. Please refresh the
          page.
        </p>
      </div>
    );
  }
  */

  return (
    <>
      {/* Intro loading screen is temporarily deisabled */}
      {/* {loading && (
        <LoadingScreen
          slideOut={slideOut}
          slideOutv2={slideOutv2}
          fadeOut={fadeOut}
        />
      )} */}

      {/* Agreement Modal temporarily disabled */}
      {/* <Modal
        isVisible={isModalVisible}
        onAgree={handleAgree}
        onDisagree={handleDisagree}
      /> */}

      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Home />} />
          {/* <Route path={PAGES.TORUMPAYCARD.path} element={<TorumPayCard />} />
          <Route path={PAGES.REFERRAL.path} element={<Referral />} /> */}
          {/* <Route path={ROUTES.COMPANY.path} element={<Company />} />
          <Route path={ROUTES.CAREER.path} element={<Career />} />
          <Route path={ROUTES.ANNOUNCEMENTS.path} element={<Announcements />} />
          <Route path={ROUTES.FEATURES.path} element={<Features />} />
          <Route path={ROUTES.COOKIEPOLICY.path} element={<CookiePolicy />} />
          <Route path={ROUTES.SECURITY.path} element={<Security />} /> 
          <Route
            path={ROUTES.COMPLIANCEINFORMATION.path}
            element={<ComplianceInformation />}
          />
          <Route path={ROUTES.TRAVELRULE.path} element={<TravelRule />} /> */}
          <Route path={ROUTES.LEARN.path} element={<Learn />} />
          <Route path={ROUTES.FEES.path} element={<Fees />} />
          <Route path={ROUTES.TERMSOFUSE.path} element={<TermsOfUse />} />
          <Route path={ROUTES.PRIVACYPOLICY.path} element={<PrivacyPolicy />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
